import React, { PropTypes } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import classNames from 'classnames';
import { icon } from './../../icons/icons';

// actions
import * as actions from './../../actions/actions';

// selectors
import { getWidgetsOnPage } from './../../selectors/selectors';

// components widgets
import Logo from './UI/Logo';
import WidgetWrapper from './Widgets/WidgetWrapper';

import Text from './Widgets/Text/Text';
import ChoiceButtons from './Widgets/Choice/ChoiceButtons';
import Datepicker from './Widgets/Datepicker/Datepicker';
import Range from './Widgets/Range/Range';
import Input from './Widgets/Input/Input';

export const DragHandle = SortableHandle(() => <div className="component--move icon icon-label">{ icon.move() } <span>Move</span></div>);

const SortableItem = SortableElement(({ activeId, mode, widget, actions }) => {
    switch (widget.kind) {
    case 'text':
        return <WidgetWrapper key={widget.id}><Text widget={widget} actions={actions} /></WidgetWrapper>;
    case 'choice':
        return <WidgetWrapper key={widget.id}><ChoiceButtons mode={mode} widget={widget} activeId={activeId} actions={actions} /></WidgetWrapper>;
    case 'date':
        return <WidgetWrapper key={widget.id}><Datepicker widget={widget} /></WidgetWrapper>;
    case 'range':
        return <WidgetWrapper key={widget.id}><Range mode={mode} widget={widget} /></WidgetWrapper>;
    case 'input':
        return <WidgetWrapper key={widget.id}><Input mode={mode} activeId={activeId} widget={widget} actions={actions} /></WidgetWrapper>;
    default:
        return <div key={0}>WIDGET NOT FOUND</div>;
    }
});

const SortableList = SortableContainer(({ activeId, mode, widgets, widgetsList, actions }) => {
    const emptyBlock = (
        <div className="component__empty__wrap">
            <div className="component__empty">Page empty. Please add some widgets to the page.</div>
        </div>
    );
    return (
        <div className="component-list">
            {(activeId === 1) ? <Logo /> : null}

            {
                (_.isEmpty(widgets)) ? emptyBlock :
                widgetsList.map((id, index) => {
                    return (
                        <SortableItem
                            key={id}
                            index={index}
                            activeId={activeId}
                            mode={mode}
                            widget={widgets[id]}
                            actions={actions}
                        />
                    );
                })
            }
        </div>
    );
});

class ContentBodyContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isComponentMoving: false,
        };
    }

    onSortStart = ({ node, index, collection }) => {
        this.setState({ isComponentMoving: true });
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState({ isComponentMoving: false });
        this.props.actions.sortWidgets(this.props.activeId, oldIndex, newIndex);
    }

    render() {
        const { activeId, mode, widgets, widgetsList, actions } = this.props;
        const widgetCss = classNames({
            'component-list--is-moving': this.state.isComponentMoving,
        });
        return (
            <div className={widgetCss}>
                <SortableList
                    onSortEnd={this.onSortEnd}
                    onSortStart={this.onSortStart}
                    useDragHandle
                    helperClass={'component--is-dragged'}
                    activeId={activeId}
                    mode={mode}
                    widgets={widgets}
                    widgetsList={widgetsList}
                    actions={actions}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    activeId: state.pages.activeId,
    mode: state.app.mode,
    widgets: getWidgetsOnPage(state),
    widgetsList: state.pages.byId[state.pages.activeId].widgets,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

ContentBodyContainer.propTypes = {
    activeId: PropTypes.number.isRequired,
    mode: PropTypes.string.isRequired,
    widgets: PropTypes.object.isRequired,
    widgetsList: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentBodyContainer);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/ContentBodyContainer.jsx